import { ArrowUpRight } from 'lucide-react';
import { MAPS_URL } from '../constants';
import { useMotion } from '../lib/motion';

const testimonials = [
  {
    name: "Ana Paula M.",
    service: "Box Braids",
    text: "Atendimento nota 1000 e trabalho impecável. Saí apaixonada pelas minhas tranças.",
  },
  {
    name: "Carla S.",
    service: "Nagô",
    text: "Ambiente acolhedor e atencioso, me senti em casa do início ao fim. Volto com certeza.",
  },
  {
    name: "Fernanda R.",
    service: "Knotless Braids",
    text: "Trabalho cuidadoso e detalhado. As melhores tranças que já fiz em Campinas.",
  },
];

export default function Testimonials() {
  const scope = useMotion();

  return (
    <section ref={scope} id="avaliacoes" data-testid="testimonials-section" className="max-w-7xl mx-auto px-4 md:px-8 py-20 md:py-28">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
        <div className="lg:col-span-4 lg:sticky lg:top-24 lg:self-start" data-testid="rating-badge">
          <h2 data-lines className="text-4xl md:text-5xl font-extrabold tracking-tight leading-none text-ink mb-6">
            O que as clientes dizem
          </h2>
          <p
            className="text-7xl md:text-8xl font-extrabold tracking-tighter text-tan leading-none tabular-nums"
            data-count="5"
            data-decimals="1"
          >
            5,0
          </p>
          <p data-rise="0.2" className="text-soft mt-2 mb-6">média de 41 avaliações no Google</p>
          <a
            href={MAPS_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-rise="0.3"
            className="inline-flex items-center gap-1 font-semibold text-ink underline decoration-tan decoration-2 underline-offset-4 hover:text-tan"
          >
            Ler no Google
            <ArrowUpRight size={18} strokeWidth={1.75} aria-hidden="true" />
          </a>
        </div>

        <div className="lg:col-span-7 lg:col-start-6 divide-y divide-rule" data-testid="testimonials-grid">
          {testimonials.map((t, i) => (
            <figure key={t.name} className="py-8 first:pt-0 last:pb-0" data-testid={`testimonial-card-${i}`}>
              <blockquote data-lines className="text-2xl md:text-3xl font-semibold tracking-tight leading-snug text-ink">
                “{t.text}”
              </blockquote>
              <figcaption data-rise="0.3" className="mt-4 text-sm">
                <span className="font-semibold text-ink">{t.name}</span>
                <span className="text-soft">, fez {t.service}</span>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
